import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

export default styled.img`
  width: 28px;
  height: 28px;
  display: block;
  margin-right: 10px;
`;
